export default __webpack_public_path__ + "static/media/logo.3f55690e.png";